import { FC } from 'react';

import { FormTabs } from 'components';
import { Stack } from 'libs/ui';
import { ClientMainInfo } from 'modules/client/common/components/ClientMainInfo';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';

import { LegalClientFirstHeadSectionsProps } from './types';
import { useLegalClientFirstHeadSections } from './useLegalClientFirstHeadSections';

export const LegalClientFirstHeadSections: FC<
  LegalClientFirstHeadSectionsProps
> = ({ countryRiskAt, ...props }) => {
  const { tabs, info } = useLegalClientFirstHeadSections(props);

  return (
    <CountryRiskProvider
      at={countryRiskAt}
      role={CountryRiskRole.LegalClientFirstHead}
    >
      <Stack spacing={36}>
        {info && <ClientMainInfo info={info} />}

        <FormTabs tabs={tabs} />
      </Stack>
    </CountryRiskProvider>
  );
};
